// extracted by mini-css-extract-plugin
module.exports = {"input_header_card":"PayForm_input_header_card__2R9hz"};